// IMPORTS
// Assets
import BarGauge from './BarGauge';


// COMPONENT
export default function Top10MostUsedDevices (props) {
   // Component
   return (
      <div className='oneport-dashboard-top10mostuseddevices oneport-dashboard-bargraph'>
         {props.parent.top10MostUsedDevices && props.parent.top10MostUsedDevices.length > 0 && props.parent.top10MostUsedDevices.map(function (item, i) {
            return (
               <BarGauge key={`oneport-dashboard-top10mostuseddevices-${i}`} title={item.device} current={item.current} max={item.max} />
            );
         })}
      </div>
   );
}